import { FaCalendar, FaClock } from "react-icons/fa6";
import { cn } from "@/lib/utils";
import useCurrentDate from "@/hooks/useCurrentDate";
import useMapStore from "@/store/mapStore";

function DateTime() {
  const mobileMode = useMapStore((state) => state.mobileMode);
  const kioskMode = useMapStore((state) => state.kioskMode);
  const { formatDate, formatTime } = useCurrentDate();

  if (mobileMode || !kioskMode) {
    return null;
  }

  return (
    <div
      className={cn(
        "absolute top-[43px] z-[6] flex min-w-60 cursor-pointer items-center justify-center rounded-xl bg-white px-4 py-2 text-lg text-primary shadow-[rgba(50,_50,_105,_0.15)_0px_2px_5px_0px,_rgba(0,_0,_0,_0.05)_0px_1px_1px_0px] group-data-[dir=ltr]:right-[208px] group-data-[dir=rtl]:left-[208px]",
      )}
    >
      <FaCalendar className="inline-block group-data-[dir=ltr]:mr-2 group-data-[dir=rtl]:ml-2" />
      <span className="text-xs text-black">{formatDate()}</span>
      <FaClock className="mx-2 inline-block" />
      <span className="text-xs font-bold text-black">{formatTime()}</span>
    </div>
  );
}

export default DateTime;
